import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/flowPie',
  title: window.language['flow.pieStatistics'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Flow/FlowPie/index.js